import { render, staticRenderFns } from "./VerificationNotification.vue?vue&type=template&id=fc0d1ad4&scoped=true&"
import script from "./VerificationNotification.vue?vue&type=script&lang=ts&"
export * from "./VerificationNotification.vue?vue&type=script&lang=ts&"
import style0 from "./VerificationNotification.vue?vue&type=style&index=0&id=fc0d1ad4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0d1ad4",
  null
  
)

export default component.exports